import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import GlobalStyles from "styles/GlobalStyles";
import Navbar from "components/yenimahalle/Navbar";
import Footer from "components/yenimahalle/Footer.js";

export const Body = styled.div`
  ${tw`
    relative
    w-full
    overflow-hidden
    2xsm:mt-26
    xsm:mt-26
    sm:mt-26
    md:mt-26
    lg:mt-28
    xl:mt-28
    2xl:mt-28
    3xl:mt-28
  `}
`;

export default function Layout({ children }) {
  return (
    <AnimationRevealPage>
      <GlobalStyles />
      <Navbar />
      <Body>
        {children}
      </Body>
      <Footer />
    </AnimationRevealPage>
  );
}
